import { render, staticRenderFns } from "./PromotionPurchaseHistoryCondition.vue?vue&type=template&id=2b0f1316&scoped=true&"
import script from "./PromotionPurchaseHistoryCondition.vue?vue&type=script&lang=js&"
export * from "./PromotionPurchaseHistoryCondition.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPurchaseHistoryCondition.vue?vue&type=style&index=0&id=2b0f1316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f1316",
  null
  
)

export default component.exports